import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
//import ImageResize from 'quill-image-resize-module-react';
import { DeltaStatic, Sources } from 'quill'
import './quill.css';

var Font = Quill.import("formats/font");
Font.whitelist = ["Roboto", "Raleway", "Montserrat", "Lato", "Rubik", "Arial", "Courier", 'Verdana'];
Quill.register(Font, true);

var BaseImageFormat = Quill.import('formats/image');
const ImageFormatAttributesList = [
    'alt',
    'height',
    'width',
    'style'
];

// class ImageFormat extends BaseImageFormat {
  
//   static formats(domNode: Element) {
//     return ImageFormatAttributesList.reduce(function(formats: any, attribute: string) {
//       if (domNode.hasAttribute(attribute)) {
//         formats[attribute] = domNode.getAttribute(attribute);
//       }
//       return formats;
//     }, {});
//   }

//   format(name: string, value: string) {
//     if (ImageFormatAttributesList.indexOf(name) > -1) {
//       if (value) {
//         this.domNode.setAttribute(name, value);
//       } else {
//         this.domNode.removeAttribute(name);
//       }
//     } else {
//       super.format(name, value);
//     }
//   }
// }
// Quill.register(ImageFormat, true);
//Quill.register('modules/imageResize', ImageResize);

interface ReactQuillEditorProps {
    fieldValue: string,
    fieldName: string,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void,
    placeholder: string
}
/*
 * Simple editor component that takes placeholder text as a prop
 */
function ReactQuillEditor({
    fieldValue,
    fieldName,
    setFieldValue,
    placeholder
  }: ReactQuillEditorProps)  {
    
    //Do not use     
    //const [editorHtml, setEditorHtml] = useState<string>(fieldValue)
    let editorHtml: string = fieldValue;
    const handleChange = (html: string, delta: DeltaStatic, source: Sources, editor: ReactQuill.UnprivilegedEditor) => {
        //console.log({html});
        //console.log({delta});
        //const contentBlock = editor.getContents();
        //console.log({contentBlock});
        editorHtml = html;
        //editorHtml = JSON.stringify(contentBlock);
        //setEditorHtml(JSON.stringify(contentBlock))
        setFieldValue(fieldName, editorHtml)
    }

    {/* <div className="text-editor">
    <EditorToolbar /> */}
    return (
      <ReactQuill
        theme={'snow'}
        onChange={handleChange}
        value={editorHtml}
        modules={modules}
        formats={formats}
        bounds={'#root'}
        placeholder={placeholder}
      />
    );
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
const modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: Font.whitelist }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    ['link', 'video'],
    [{color: [] }, {background: []}],
    ['clean']
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false
  },
  // imageResize: {
  //   parchment: Quill.import('parchment'),
  //   modules: [
  //     'Resize', 
  //     'DisplaySize',
  //   ],
  // },
};

/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'background',
  'list',
  'bullet',
  'indent',
  'link',
  //'image',
  'video',
  'color'
];

export default ReactQuillEditor;